// components/MessageReactions.tsx
import React, { useState } from "react";
import { IonPopover, IonContent } from "@ionic/react";
import { Message } from "../../interfaces";

interface Props {
  message: Message;
}

const MessageReactions: React.FC<Props> = ({ message }) => {
  const [popoverEvent, setPopoverEvent] = useState<Event | undefined>();

  if (!message.reactions?.length) return null;

  return (
    <>
      <div
        className="chat-item-reactions"
        onClick={(e: React.MouseEvent<HTMLDivElement>) => {
          setPopoverEvent(e.nativeEvent);
        }}
      >
        <div className="chat-item-reactions-wrapper">
          {message.reactions.map((reaction, i) => (
            <span key={i} className="chat-item-reaction emoji fs-2">
              {reaction.emoji}
            </span>
          ))}
        </div>
      </div>

      <IonPopover
        event={popoverEvent}
        isOpen={!!popoverEvent}
        side={message.right ? "left" : "right"}
        alignment="start"
        showBackdrop={false}
        onDidDismiss={() => setPopoverEvent(undefined)}
      >
        <IonContent class="ion-padding">
          <div className="pop-over-reactions">
            {message.reactions.map((reaction, i) => (
              <div key={i} className="pop-over-reactions-wrapper">
                <span className="fs-2 fw-bold color-step-700 pop-over-reactions-name">
                  {reaction.from}
                </span>
                <span className="emoji fs-2">{reaction.emoji}</span>
              </div>
            ))}
          </div>
        </IonContent>
      </IonPopover>
    </>
  );
};

export default MessageReactions;
